import { AppController } from "../AppController";
var LicensePage = /** @class */ (function () {
    function LicensePage(_appController) {
        this._appController = _appController;
        this._swissNumberFormatter = new Intl.NumberFormat("de-CH");
    }
    Object.defineProperty(LicensePage.prototype, "appController", {
        get: function () {
            return this._appController;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LicensePage.prototype, "organization", {
        get: function () {
            return this.appController.organization;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LicensePage.prototype, "availableLicenseTypes", {
        get: function () {
            return this.appController.availableLicenseTypes;
        },
        enumerable: true,
        configurable: true
    });
    LicensePage.prototype.formatPrice = function (licensePrice) {
        return this._swissNumberFormatter.format(licensePrice);
    };
    Object.defineProperty(LicensePage.prototype, "newLicenseTypeName", {
        get: function () {
            return this.organization.newLicenseTypeName;
        },
        set: function (newLicenseTypeName) {
            this.organization.setNewLicenseType(this.availableLicenseTypes.find(function (licenseType) { return licenseType.name === newLicenseTypeName; }));
        },
        enumerable: true,
        configurable: true
    });
    return LicensePage;
}());
export { LicensePage };
